import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  get_opportunity,
  update_opportunity_status,
} from "../../../services/apis/opportunity";
// import { setLoading } from "../../../store/slices/opportunity";
import { LuCalendar, LuTag, LuCircleCheck } from "react-icons/lu";
import { Switch } from "antd";
import { format_date_time } from "../../../services/convert/date";
import { CgArrowLongLeft } from "react-icons/cg";
import Button from "../../../component/element/forms/Button";

import { FileText } from "lucide-react";
// import { data } from "@/src/constants/delete";

const ViewOpportunityDetail: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const opportunity = useAppSelector(
    ({ opportunity }) => opportunity.opportunity,
  );
  const loading = useAppSelector(({ opportunity }) => opportunity.loading);

  const onLoad = React.useCallback(() => {
    if (id) get_opportunity(dispatch, id);
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const isActive = opportunity?.status === "1";

  const handleStatusUpdate = async () => {
    await update_opportunity_status(opportunity?.id ?? "", dispatch);
  };

  return (
    <div>
      <div className="flex justify-end space-x-3 mb-6">
        <Button
          title="Back"
          children={<CgArrowLongLeft className="mr-2" />}
          onClick={() => navigate(-1)}
          className="ml-4 bg-primary-500 hover:bg-primary-800 w-32 text-white"
        />

        <div className="flex items-center gap-3 border border-gray-200 px-3 py-1 rounded-md">
          <span className="font-medium">Status</span>

          <Switch
            checked={opportunity?.status === "1" ? true : false}
            loading={loading}
            onChange={handleStatusUpdate}
          />
        </div>
      </div>
      <div className="grid gap-8 lg:grid-cols-3 items-start">
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm overflow-hidden">
          {/* Hero Image Section */}
          <div
            style={{
              backgroundImage: `url(${opportunity?.opportunity_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            className="relative h-[400px] w-full"
          >
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            {/* Title and Status */}
            <div className="absolute bottom-4 left-4 right-4">
              <h2 className="text-3xl font-bold text-white">
                {opportunity?.opportunity_name}
              </h2>
            </div>
            {/* Status Badge */}
            <div className="absolute top-4 right-4">
              <div
                className={`
              inline-flex items-center px-3 py-1 rounded-full text-xs tracking-wider font-semibold backdrop-blur-sm
              ${isActive ? "bg-primary-100/70 text-primary-800" : "bg-gray-100/70 text-gray-800"}
            `}
              >
                <LuCircleCheck className="size-3 mr-1.5" />
                {isActive ? "Active" : "Inactive"}
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="px-8 py-6">
            {/* Meta Information */}
            <div className="flex items-center justify-between text-sm text-gray-500">
              <div className="flex items-center space-x-6">
                <div className="flex items-center">
                  <LuCalendar className="size-4 mr-1.5" />
                  <span>
                    {format_date_time(opportunity?.expire_date as Date)}
                  </span>
                </div>

                <div className="flex items-center font-medium capitalize px-3 py-1 rounded-full bg-gray-100/30 ">
                  <LuTag className="size-4 mr-1.5" />
                  <span>{opportunity?.type.name}</span>
                </div>
              </div>

              {/* View PDF Doument  */}
              {/* <div
                onClick={() => window.open(opportunity?.opportunity_file)}
                className="group flex items-center border transition hover:bg-gray-300 hover:text-gray-900 duration-300 rounded-lg px-3 py-2 cursor-pointer"
              >
                <span className="font-medium mr-1.5">View PDF</span>
                <LuFile className="size-4 text-gray-500 group-hover:text-gray-900" />
              </div> */}
            </div>

            <hr className="mt-6 text-gray-200" />

            {/* Description */}
            <div className="mt-6 max-w-none">
              <div
                className="text-base font-normal text-gray-600 leading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: opportunity?.opportunity_description || "",
                }}
              />
            </div>
          </div>
        </div>
        <div className="colum_two rounded-xl shadow-sm p-6 flex-shrink bg-white">
          <div className="pb-3">
            <h3 className="text-lg font-semibold">Document Files</h3>
          </div>
          <div className="space-y-4">
            {opportunity?.opportunities_files.map((file, index) => (
              <div key={index}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 flex-1">
                    {/* Document Icon */}
                    <div className="flex-shrink-0 bg-primary-50/20 p-2 rounded-md text-primary-600">
                      <FileText />
                    </div>

                    {/* Document Details */}
                    <div className="flex-1">
                      <h3 className="text-lg font-medium text-gray-900">
                        Opportunity file {index + 1}
                      </h3>
                    </div>
                  </div>

                  {/* View Button */}
                  <Link
                    to={file}
                    target="_blank"
                    className="ml-4 bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                  >
                    View
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOpportunityDetail;
